export default {
    // 查询托管树形接口
    findTrusteeshipTree(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/tableController/findTrusteeshipTree', params, response);
    },

    // 查询编辑初始化信息详细信息
    queryInitOptionsDetail(params, response) {
        return window.vue.$apiAxios.get('/setting/tableController/queryInitOptionsDetail', params, response);
    },

    // 批量同步
    batchSyncTrusteeship(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/tableController/batchSyncTrusteeship', params, response);
    },

    // 托管表同步接口
    syncTrusteeship(params, response) {
        return window.vue.$apiAxios.post('/setting/tableController/syncTrusteeship', params, response);
    },

    // 查询托管表
    listTrusteeshipTables(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/tableController/listTrusteeshipTables', params, response);
    },

    // 批量删除托管
    deleteTrusteeship(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/tableController/deleteTrusteeship', params, response);
    },

    // 添加托管表
    insertTrusteeship(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/tableController/insertTrusteeship', params, response);
    },

    // 更新托管表
    updateTrusteeship(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/tableController/updateTrusteeship', params, response);
    },

    // 查询未托管的表信息
    listUnTrusteeshipTables(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/tableController/listUnTrusteeshipTables', params, response);
    },

    // 根据托管id查询托管字段信息
    listColumnsByTrusteeshipId(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/tableController/listColumnsByTrusteeshipId', params, response);
    },

    // 更新托管字段信息
    updateTrusteeshipColumn(params, response) {
        return window.vue.$apiAxios.postRequestBody('/setting/tableController/updateTrusteeshipColumn', params, response);
    }
};
